/**
 * Obliga a cambiar la contraseña cuando passwordChangeRequired.
 */
import React, { useState } from 'react';
import { studio } from './admin/studioUi';
import { useAuth } from '../AuthContext';
import AuthShell, {
    AUTH_API_URL,
    AuthField,
    AuthNotice,
    PasswordToggle,
    validateNewPassword,
} from './AuthShell';

const ForcePasswordChange = ({ user, onPasswordChanged, API_URL, fetchWithAuth }) => {
    const { withBusy } = useAuth();
    const apiBase = API_URL || AUTH_API_URL;
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [verPassword, setVerPassword] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handlePasswordUpdate = async (e) => {
        e.preventDefault();
        setError('');

        const validationErrors = validateNewPassword(password);
        if (validationErrors.length > 0) {
            setError(`La contraseña debe ${validationErrors.join(', ')}.`);
            return;
        }
        if (password !== confirmPassword) {
            setError('Las contraseñas no coinciden.');
            return;
        }

        setLoading(true);
        try {
            await withBusy(async () => {
            await fetchWithAuth(`${apiBase}/user/update-password/${user.uid}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ password }),
            });
            await fetchWithAuth(`${apiBase}/user/update-password-flag/${user.uid}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ required: false }),
            });
            onPasswordChanged();
            }, 'Guardando contraseña…');
        } catch (err) {
            setError(err.message || 'No se pudo actualizar la contraseña.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthShell
            kicker="Seguridad"
            title="Nueva contraseña"
            subtitle="Por seguridad debes establecer una contraseña propia antes de continuar."
        >
            <form onSubmit={handlePasswordUpdate} autoComplete="on">
                <AuthField label="Nueva contraseña" htmlFor="force-password">
                    <div style={{ position: 'relative' }}>
                        <input
                            id="force-password"
                            name="new-password"
                            type={verPassword ? 'text' : 'password'}
                            autoComplete="new-password"
                            maxLength={128}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            style={{ ...studio.control, paddingRight: 48 }}
                            required
                        />
                        <PasswordToggle show={verPassword} onToggle={() => setVerPassword((v) => !v)} />
                    </div>
                </AuthField>
                <AuthField label="Confirmar contraseña" htmlFor="force-password-confirm">
                    <input
                        id="force-password-confirm"
                        name="confirm-password"
                        type={verPassword ? 'text' : 'password'}
                        autoComplete="new-password"
                        maxLength={128}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        style={studio.control}
                        required
                    />
                </AuthField>
                <AuthNotice type="error">{error}</AuthNotice>
                <button
                    type="submit"
                    style={{ ...studio.primaryBtn, width: '100%', minHeight: 46, fontSize: '1rem', opacity: loading ? 0.7 : 1 }}
                    disabled={loading}
                >
                    {loading ? 'Guardando…' : 'Establecer contraseña'}
                </button>
            </form>
        </AuthShell>
    );
};

export default ForcePasswordChange;
